<template>
  <Loader v-if="loader" />
  <div class="card">
    <div class="formgrid grid ">
      <div class="field col-12 md:col-4">
        <label>Fornitori</label>
        <MultiSelect v-model="selectedFornitori" :options="fornitori" :filter="true" optionLabel="ragsoc"
          optionGroupLabel="label" optionGroupChildren="items" placeholder="Seleziona fornitore"
          :class="['inputfield w-full', { 'p-invalid': validationErrors.fornitore && submitted }]" />
        <div v-show="validationErrors.fornitore && submitted" class="p-error">Seleziona fornitore.</div>
      </div>
      <div class="field col-12 md:col-6">
        <label>Emissione</label>
        <Calendar v-model="data_emissione" :showIcon="true" view="year" dateFormat="yy"
          :class="['inputfield w-full', { 'p-invalid': validationErrors.data_emissione && submitted }]" />
        <div v-show="validationErrors.data_emissione && submitted" class="p-error">Seleziona anno.</div>
      </div>
      <div class="field col-12 md:col-2 flex align-items-end justify-content-center">
        <Button label="Cerca" icon="pi pi-search" iconPos="left" class="w-full" @click="searchData" />
      </div>
    </div>
  </div>
  <div class="card" v-if="items && Object.keys(items).length > 0">
    <div v-for="(objs, type) in items" :key="type" class="mb-6">
      <div v-if="objs.length > 0">
        <h3>{{ type }}</h3>
        <DataTable :value="objs">
          <Column field="fornitore" header="Fornitore"></Column>
          <Column field="totale_energia" header="Totale Materia Energia"></Column>
          <Column field="totale_imponibile" header="Totale Imponibile">
            <template #body="{ data }">
              {{ formatCurrency(data.totale_imponibile) }}
            </template>
          </Column>
        </DataTable>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import Service from '@/services/ask-pratiche/pratiche-service'
import { ref, onMounted, getCurrentInstance } from 'vue';
import { FilterMatchMode } from 'primevue/api';
import Loader from '@/components/Loader.vue'


export default {
  components: {
    Loader
  },
  setup() {

    const dt = ref();
    const loader = ref(false)
    const invoices = ref([]);
    const filters = ref({
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    self.$http = self.appContext.config.globalProperties.$http
    const service = new Service(self.$http, self.$eventBus)
    const formatDate = self.appContext.config.globalProperties.$formatDate
    const data_emissione = ref();
    const fornitori = ref([]);
    const selectedFornitori = ref()
    const items = ref()
    const validationErrors = ref({})
    const submitted = ref(false)

    onMounted(() => {
      getFornitoriHasDetailsEe()
      getFornitoriHasDetailsGas()
    })
    const searchData = () => {
      submitted.value = true;
      if (validateData()) {
        loader.value = true
        service.getQuantitaMateriaFornitoriDogane(
          moment(data_emissione.value).format('YYYY'),
          selectedFornitori.value,
        ).then((res) => {
          items.value = res.items
        }).finally(() => {
          loader.value = false
        })
      }
    }

    const getFornitoriHasDetailsEe = () => {
      loader.value = true
      service.getFornitoriControlloFattureHasDetailsEe()
        .then((res) => {
          fornitori.value.push(
            {
              label: 'Energia',
              items: res.items
            }
          )
        }).finally(() => {
          loader.value = false
        })
    }

    const getFornitoriHasDetailsGas = () => {
      loader.value = true
      service.getFornitoriControlloFattureHasDetailsGas()
        .then((res) => {
          fornitori.value.push(
            {
              label: 'Gas',
              items: res.items
            }
          )
        }).finally(() => {
          loader.value = false
        })
    }

    const formatCurrency = (value) => {
      return value.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' });
    };


    const validateData = () => {
      if (data_emissione.value == null)
        validationErrors.value['data_emissione'] = true;
      else
        delete validationErrors.value['data_emissione'];

      if (selectedFornitori.value && selectedFornitori.value.length > 0)
        delete validationErrors.value['fornitore'];
      else
        validationErrors.value['fornitore'] = true;

      return !Object.keys(validationErrors.value).length;
    }

    const exportCSV = () => {
      dt.value.exportCSV();
    };


    return {
      dt,
      invoices,
      loader,
      filters,
      data_emissione,
      fornitori,
      selectedFornitori,
      items,
      searchData,
      formatDate,
      exportCSV,
      validationErrors,
      submitted,
      formatCurrency
    }
  }
}
</script>

<style scoped></style>
